import { useEffect } from "react";
import { useLocation } from "react-router";
import ReactGA from "react-ga4";

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
}

export function PageTracker() {
  usePageTracking();
  return null;
}
